<style src="vue2-dropzone/dist/vue2Dropzone.min.css"></style>
<style scoped lang="scss">
.image {
  max-width: 200px;
}
.invalid-feedback {
  display: block;
}
</style>

<template>
  <div>
    <vue-dropzone
      :class="{ 'is-invalid': hasErrors, [colClass]: true }"
      id="gift-image-upload"
      :options="dropzoneOptions"
      ref="upload"
      v-model="modelValue"
      @vdropzone-file-added="fileAdded"
    ></vue-dropzone>
    <div
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
    <div class="image" v-if="value && isUpdateMode && !previousFile">
      <img type="file" :src="imageUrl" />
    </div>
  </div>
</template>

<script lang="babel">
import vue2Dropzone from 'vue2-dropzone'
import { CSRFToken } from '@/communication';


export default {
  components: {
    vueDropzone: vue2Dropzone,
  },

  computed: {
    imageUrl() {
      return `/api/v1/gift/${this.value}`;
    },
    dropzoneOptions() {
      return {
        dictDefaultMessage: "Klick oder drag und drop ein Bild hier.",
        url: this.uploadUrl,
        thumbnailWidth: 150,
        maxFilesize: 20,
        maxFiles: 1,
        acceptedFiles: "image/*",
        headers: { "X-CSRF-TOKEN": CSRFToken() },
        autoProcessQueue: false,
      };
    },
    colClass() {
      const col = this.attribute.col !== undefined ? this.attribute.col : 12;
      return `col-${col}`;
    },
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
    isUpdateMode(){
      return this.attribute.updateMode ? this.attribute.updateMode : false;
    }
  },

  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      uploadUrl: '/api/v1/gift/upload/',
      modelValue: this.value,
      previousFile: null
    };
  },
  methods: {
    fileAdded(file) {
      if (this.previousFile) {
        this.$refs.upload.removeFile(this.previousFile);
      }
      document.querySelector(".dz-progress").style.opacity = "0.0";

      this.$emit('input',file);
      this.previousFile = file;
    }
  }
}
</script>
